<template>
  <div id="login" class="d-flex justify-center align-center">
    <v-form id="panel">
      <v-card class="">
        <v-card-title>登入</v-card-title>
        <v-card-text class="d-flex flex-column justify-center pb-0">
          <v-text-field
            label="帳號"
            outlined
          ></v-text-field>
          <v-text-field
            label="密碼"
            type="password"
            outlined
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" large block>登入</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { auth } from '@/firebase'

export default {
  data: () => ({
    email: '',
    password: ''
  }),
  created () {
    const self = this
    auth.onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        self.goToAdmin()
      } else {
        // User is signed out.
      }
    })
    const qs = new URLSearchParams(location.search)
    // ac: account, pw: passowrd
    if (qs.has('ac') && qs.has('pw')) {
      this.email = qs.get('ac')
      this.password = qs.get('pw')
      this.login()
    }
  },
  methods: {
    ...mapMutations({
      showDialog: 'SHOW_DIALOG',
      startLoading: 'START_LOADING',
      closeDialog: 'CLOSE_DIALOG'
    }),
    async login () {
      this.startLoading()
      try {
        const result = await auth.signInWithEmailAndPassword(this.email, this.password)
        this.closeDialog()
        // 如果沒有登入成功，user會是null
        // https://firebase.google.com/docs/reference/js/firebase.auth.Auth#signinwithemailandpassword
        if (result.user) {
          this.goToAdmin()
        }
      } catch (error) {
        this.showDialog({
          title: '登入失敗',
          content: `錯誤訊息: ${error.message}`
        })
      }
    },
    goToAdmin () {
      this.$router.push({ name: 'Admin' })
    }
  }
}
</script>
<style lang="scss" scoped>
#login {
  height: 100%;
}

#panel {
  max-width: 400px;
  width: 100%;
}
</style>
